export const AUTH_LOCALE_EN = {
  AUTH: {
    FIELD: {
      EMAIL: 'Email',
      PASSWORD: 'Password',
      CONFIRM_PASSWORD: 'Confirm password',
      NEW_PASSWORD: 'New password',
    },
    LOGIN: {
      SUBTITLE: 'Sign in with your IBSOA account to manage bookings and customers.',
      RESTRICTED:
        'IBSOA staff only. If you need an account, ask the administration team.',
      TITLE: 'Back office sign-in',
      FORGOT_PASSWORD: 'Forgot your password?',
      FORGOT_PASSWORD_GO: 'Reset here',
    },
    FORGOT_PASSWORD: {
      TITLE: 'Sign in to the console',
      SUBTITLE: 'Enter your email to reset your password.',
    },
    RESET_PASSWORD: {
      TITLE: 'Reset password',
      CODE_LABEL: 'Verification code',
      CREATE_NEW_PASSWORD: 'Create your new password',
      NEW_PASSWORD_SUBTITLE:
        'Set a strong new password to continue with account access.',
      CODE_REQUIRED: 'You must enter the 8-character code sent to your email.',
      INVALID_CODE: 'The code is invalid or has expired. Please request a new one.',
      TOO_MANY_ATTEMPTS: 'Too many attempts. Please wait a moment and try again.',
      TOKEN_EXPIRED:
        'Your reset session has expired. Please request a new code.',
      SUBTITLE:
        "Enter the code and your new password to access <b>{{ name }}</b>. If you can't find the code, it might be in your spam folder.",
    },
  },
};
